import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
const FormFieldLoading = ({
  classes,
  label,
  placeholder
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.formFieldLoadingContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "body1"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: classes.placeholderContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, placeholder)));
};
const styles = () => ({
  formFieldLoadingContainer: {
    display: "flex",
    flex: 1,
    height: 52,
    flexDirection: "column"
  },
  placeholderContainer: {
    padding: "0px 18px 5px 0px",
    marginTop: 5
  }
});
export default withStyles(styles)(FormFieldLoading);
FormFieldLoading.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
};